document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
const stage = document.querySelector('[data-pulse-stage]');
const sections = stage ? [...stage.querySelectorAll('[data-pulse-section]')] : [];
let pulse = null;
let site = null;
let chapters = null;
let scene = null;
let heroLoop = null;
const kineticTitleScenes = [];

if (window.Pulse) pulse = new window.Pulse({ motion: { reducedMotion, speed: 1, frameRate: 60 } });

const setActive = (index) => {
  const section = sections[index];
  if (!section) return;
  sections.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
  document.body.dataset.surface = section.dataset.surface || 'light';
  document.querySelectorAll('[data-chapter-target]').forEach((control) => {
    if (control.dataset.chapterTarget === section.id) control.setAttribute('aria-current', 'true');
    else control.removeAttribute('aria-current');
  });
  const count = document.querySelector('[data-chapter-count]');
  if (count) count.textContent = String(index + 1).padStart(2, '0');
  const progress = document.querySelector('[data-chapter-progress]');
  if (progress) progress.style.setProperty('--chapter-progress', `${((index + 1) / sections.length) * 100}%`);
  if (heroLoop) {
    if (section.hasAttribute('data-hero-pulse')) heroLoop.resume();
    else heroLoop.pause();
  }
  if (!pulse) return;
  scene?.dispose?.();
  scene = pulse.timelineEngine({ autoplay: true, timeUnit: 'seconds', reducedMotion })
    .add(section.querySelectorAll('[data-reveal]'), { opacity: [0, 1], translateY: [28, 0], duration: 0.72, ease: 'outExpo', stagger: 0.07 })
    .init();
};

const hero = document.querySelector('[data-hero-pulse]');
if (hero && pulse && !reducedMotion) {
  const titleLine = hero.querySelector('[data-hero-title-line]');
  const titleAccent = hero.querySelector('[data-hero-title-accent]');
  const titleEcho = hero.querySelector('.hero-title__echo');
  const signal = hero.querySelector('[data-hero-signal]');
  const artImage = hero.querySelector('[data-hero-art-image], .hero-art img');
  const scan = hero.querySelector('[data-hero-scan]');
  const reticle = hero.querySelector('[data-hero-reticle]');
  const stamp = hero.querySelector('[data-hero-stamp]');
  heroLoop = pulse.timelineEngine({ autoplay: true, timeUnit: 'seconds', reducedMotion, loop: true, loopDelay: 0.35 })
    .label('campaign-breathe', 0)
    .add(titleLine, { translateX: [0, 8, -2, 0], skewX: [0, -1.2, 0.4, 0], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .add(titleAccent, { translateX: [0, -6, 3, 0], scale: [1, 1.02, 0.995, 1], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .add(titleEcho, { translateX: [6, -5, 9, 6], opacity: [0.12, 0.34, 0.18, 0.12], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .add(signal, { scaleX: [0.12, 1, 0.42, 0.9, 0.12], opacity: [0.45, 1, 0.58, 1, 0.45], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .add(artImage, { scale: [1.03, 1.07, 1.045, 1.03], translateX: [0, -10, 5, 0], translateY: [0, -4, 2, 0], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .add(reticle, { rotate: [0, 90, -24, 0], scale: [0.94, 1.05, 0.98, 0.94], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .add(stamp, { rotate: [-2, 3, -2], scale: [1, 1.045, 1], duration: 6.4, ease: 'inOutSine' }, 'campaign-breathe')
    .label('scan-pass', 0.55)
    .add(scan, { translateY: ['-130%', '230%'], opacity: [0, 0.9, 0.9, 0], duration: 4.8, ease: 'linear' }, 'scan-pass')
    .init();
} else if (hero) {
  hero.classList.add('is-motion-static');
}

if (stage && sections.length) {
  const rail = document.createElement('nav');
  rail.className = 'chapter-rail';
  rail.setAttribute('aria-label', 'Homepage sections');
  rail.innerHTML = sections.map((section, index) => `<button type="button" data-chapter-target="${section.id}" aria-label="Section ${index + 1}"></button>`).join('');
  const meter = document.createElement('div');
  meter.className = 'chapter-meter';
  meter.setAttribute('data-chapter-progress', '');
  meter.innerHTML = `<span data-chapter-count>01</span> / ${String(sections.length).padStart(2, '0')}`;
  document.body.append(rail, meter);
  if (pulse) {
    site = pulse.site({ id: 'needle-n-threads', mode: 'commerce', root: document.documentElement });
    chapters = site.chapterStage({
      root: document,
      sections,
      stageArt: sections,
      labels: sections.map((section) => section.id),
      threshold: [0.45, 0.65, 0.85],
      initialIndex: 0,
      onChange: setActive
    });
    site.ready = true;
  } else {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible) setActive(sections.indexOf(visible.target));
    }, { root: stage, threshold: [0.5, 0.75] });
    sections.forEach((section) => observer.observe(section));
  }
  setActive(0);
}

document.querySelectorAll('[data-kinetic-title]').forEach((title) => {
  const text = title.querySelector('.kinetic-title__text');
  const echo = title.querySelector('.kinetic-title__echo');
  if (!pulse || reducedMotion || !text || !echo) {
    title.classList.add('is-motion-static');
    return;
  }
  const titleScene = pulse.timelineEngine({ autoplay: true, timeUnit: 'seconds', reducedMotion, loop: true, loopDelay: 1.8 })
    .label('settle', 0)
    .add(text, { translateX: [0, 5], skewX: [0, -1.2], duration: 0.7, ease: 'outExpo' }, 'settle')
    .add(echo, { opacity: [0.12, 0.34], translateX: [-4, 8], duration: 0.7, ease: 'outExpo' }, 'settle')
    .label('accent', 0.7)
    .add(text, { translateX: [5, -2], scaleX: [1, 1.008], duration: 0.22, ease: 'inOutQuad' }, 'accent')
    .add(echo, { opacity: [0.34, 0.2], translateX: [8, -5], duration: 0.22, ease: 'inOutQuad' }, 'accent')
    .label('return', 0.92)
    .add(text, { translateX: [-2, 0], skewX: [-1.2, 0], scaleX: [1.008, 1], duration: 0.58, ease: 'outExpo' }, 'return')
    .add(echo, { opacity: [0.2, 0.12], translateX: [-5, -4], duration: 0.58, ease: 'outExpo' }, 'return')
    .timer({ duration: 2.6 }, 1.5)
    .init();
  kineticTitleScenes.push(titleScene);
});

document.addEventListener('visibilitychange', () => {
  kineticTitleScenes.forEach((titleScene) => document.hidden ? titleScene.pause() : titleScene.resume());
  if (heroLoop) document.hidden ? heroLoop.pause() : heroLoop.resume();
});

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(open));
    menu.hidden = !open;
  }
  const chapterControl = event.target.closest('[data-chapter-target]');
  if (chapterControl) {
    const target = document.getElementById(chapterControl.dataset.chapterTarget);
    const index = sections.indexOf(target);
    if (!target || index < 0) return;
    chapters?.select?.(index);
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  }
  if (event.target.closest('[data-mobile-menu] a')) {
    const menu = document.querySelector('[data-mobile-menu]');
    const toggle = document.querySelector('[data-menu-toggle]');
    if (menu && toggle) {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }
  }
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('[name="id"]');
  const button = form.querySelector('[type="submit"]');
  if (!select || !button) return;
  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    button.disabled = option.dataset.available !== 'true';
    button.querySelector('span').textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
  });
  form.addEventListener('submit', async (event) => {
    if (!event.submitter || event.submitter.name !== 'add') return;
    event.preventDefault();
    const label = button.querySelector('span');
    const originalLabel = label.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this item. Please check the selected option.');
      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      const live = document.querySelector('[data-live-region]');
      if (live) live.textContent = error.message;
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = select.selectedOptions[0]?.dataset.available !== 'true';
      label.textContent = originalLabel;
    }
  });
});

const openCartDrawer = () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  if (!drawer.open) drawer.showModal();
  document.body.classList.add('cart-is-open');
  const panel = drawer.querySelector('.cart-drawer__panel');
  if (pulse && panel) pulse.timelineEngine({ autoplay: true, timeUnit: 'seconds', reducedMotion }).add(panel, { opacity: [0.72, 1], translateX: [70, 0], duration: 0.34, ease: 'outExpo' }).init();
  drawer.querySelector('[data-cart-close]')?.focus();
};

const closeCartDrawer = () => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer?.open) return;
  drawer.close();
  document.body.classList.remove('cart-is-open');
};

const refreshCartDrawer = async () => {
  const root = window.Shopify?.routes?.root || '/';
  const [sectionResponse, cartResponse] = await Promise.all([fetch(`${root}?section_id=cart-drawer`), fetch(`${root}cart.js`)]);
  if (!sectionResponse.ok || !cartResponse.ok) throw new Error('The cart could not be refreshed.');
  const html = await sectionResponse.text();
  const cartState = await cartResponse.json();
  const nextDrawer = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
  const currentDrawer = document.querySelector('[data-cart-drawer]');
  if (nextDrawer && currentDrawer) currentDrawer.replaceWith(nextDrawer);
  document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cartState.item_count; });
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-toggle]')) {
    event.preventDefault();
    openCartDrawer();
  }
  if (event.target.closest('[data-cart-close]')) closeCartDrawer();
});

document.querySelectorAll('.nav-category').forEach((category) => {
  category.addEventListener('toggle', () => {
    if (!category.open) return;
    document.querySelectorAll('.nav-category').forEach((other) => {
      if (other !== category) other.open = false;
    });
  });
});

document.addEventListener('click', (event) => {
  if (event.target.closest('.nav-category')) return;
  document.querySelectorAll('.nav-category[open]').forEach((category) => { category.open = false; });
});

window.__needleThreadsPulse = () => ({
  owner: pulse ? 'Pulse' : 'native-fallback',
  version: pulse?.version || null,
  sections: sections.length,
  activeSection: sections.find((section) => section.classList.contains('is-active'))?.id || null,
  site: site?.proof?.() || null
});

addEventListener('pagehide', () => pulse?.dispose?.(), { once: true });
